import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { h } from 'preact';
import { styled } from 'linaria/react';
import { useEffect, useState } from 'preact/hooks';

import { Button } from 'ui/atoms/button';
import { ErrorType } from 'model/error.model';
import { ReloadIcon } from 'ui/icons/reload-icon';
import { sendEvent } from 'model/helpers/events.model';
import { useLocalization } from 'model/localization.model';
import { fallbackCancel } from 'model/flows/fallback.model';
import { ErrorLayout } from 'features/fallback/ui/error-layout';

export const InvalidSession = () => {
	const t = useLocalization();
	const [start] = useState(Date.now());

	useEffect(() => {
		screenHistoryPush(ScreenName.invalid_session_desktop);
		setTimeout(() => {
			sendEvent({
				event: 'invalid_session_screen_shown',
				event_attributes: {
					type: 'desktop',
				},
			});
		}, 20)
	}, []);
	const handleRestart = () => {
		sendEvent({
			event: 'invalid_session_restart',
			event_attributes: {
				type: 'desktop',
				duration: Date.now() - start,
			},
		});
		fallbackCancel(ErrorType.invalid_session);
	};

	return (
		<ErrorLayout
			title={t('session.err.title')}
			description={t('desktop.err.subtitle')}
		>
			<ButtonContainer>
				<Button
					onClick={handleRestart}
					icon={<ReloadIcon fill={'white'}/>}
				>
					Start over
				</Button>
			</ButtonContainer>
		</ErrorLayout>
	);
};
const ButtonContainer = styled('div')`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
`;
